import { c as _c } from "react/compiler-runtime";
import { useVillaTranslation } from "@website/accommodation-ui/villa-search/villa-search-panel/hooks/use-villa-translation";
import { MaterialIcon } from "@website/icons/material";
import pick from "lodash-es/pick";
import toString from "lodash-es/toString";
import { useEffect, useState } from "react";
const getDestinationLatitude = (destination: any) => (Array.isArray(destination?.location) ? destination.location[0] : destination?.location?.latitude) ?? destination?.location?.lat ?? destination?.lat;
const getDestinationLongitude = (destination: any) => (Array.isArray(destination?.location) ? destination.location[1] : destination?.location?.longitude) ?? destination?.location?.lon ?? destination?.long ?? destination?.lng;
const hasDestinationCoordinates = (destination: any) => Boolean(getDestinationLatitude(destination) && getDestinationLongitude(destination));
export const canShowVillaDestinationOnMap = (destination: any) => hasDestinationCoordinates(destination) && destination?.hotel_count > 0;
export const useHistory = (onChangeDestination, t0) => {
  const $ = _c(15);
  const shouldRequireCoordinates = t0 === undefined ? false : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [history, setHistory] = useState(t1);
  const {
    translateEntity
  } = useVillaTranslation();
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (localStorage) {
        const historyString = localStorage.getItem("villa-search-history-v4");
        const history_0 = historyString ? JSON.parse(historyString) : [];
        setHistory(history_0);
      }
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (destination, startDate, endDate, passengerNumber) => {
      if (localStorage) {
        const historyString_0 = localStorage.getItem("villa-search-history-v4");
        const history_1 = historyString_0 ? JSON.parse(historyString_0) : [];
        let newHistory = history_1.filter(item => toString(item.destination.id) !== toString(destination.id));
        const newHistoryItem = {
          destination,
          startDate,
          endDate,
          passengerNumber,
          hotel_count: 0
        };
        newHistory = [newHistoryItem, ...newHistory].slice(0, 4);
        localStorage.setItem("villa-search-history-v4", JSON.stringify(newHistory));
        setHistory(newHistory);
      }
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const addToHistory = t4;
  let onSelectHistory;
  let t5;
  if ($[4] !== history || $[5] !== onChangeDestination || $[6] !== shouldRequireCoordinates || $[7] !== translateEntity) {
    const visibleHistory = shouldRequireCoordinates ? history.filter(_temp) : history;
    onSelectHistory = id => {
      if (visibleHistory) {
        let historyItem = null;
        for (const element of visibleHistory) {
          const checkKey = `${element.destination.id}`;
          if (`${id}` === checkKey) {
            historyItem = element.destination;
            break;
          }
        }
        if (historyItem) {
          onChangeDestination(historyItem);
        }
      }
    };
    let t6;
    if ($[10] !== translateEntity) {
      t6 = t7 => {
        const {
          destination: destination_2
        } = t7;
        return {
          ...pick(destination_2, ["id", "title"]),
          subtitle: translateEntity(destination_2.subtitle),
          StartIcon: <MaterialIcon name="history" variant="outlined" />,
          Meta: <div className="text-on-surface-high-emphasis text-caption" />
        };
      };
      $[10] = translateEntity;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = visibleHistory.filter(_temp2).map(t6);
    $[4] = history;
    $[5] = onChangeDestination;
    $[6] = shouldRequireCoordinates;
    $[7] = translateEntity;
    $[8] = onSelectHistory;
    $[9] = t5;
  } else {
    onSelectHistory = $[8];
    t5 = $[9];
  }
  const historyListNormalized = t5;
  let t6;
  if ($[12] !== historyListNormalized || $[13] !== onSelectHistory) {
    t6 = {
      historyListNormalized,
      addToHistory,
      onSelectHistory
    };
    $[12] = historyListNormalized;
    $[13] = onSelectHistory;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
function _temp(t0) {
  const {
    destination: destination_0
  } = t0;
  return canShowVillaDestinationOnMap(destination_0);
}
function _temp2(t0) {
  const {
    destination: destination_1
  } = t0;
  return destination_1?.title && destination_1?.url && destination_1?.type;
}